import './Pagination.scss';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Pagination({ pageIndex, totalCount, pageSize, onPageChange, onPageSizeChange, pageSizes = [5, 10, 15] }) {
  const { t } = useTranslation();
  const [showSizeMenu, setShowSizeMenu] = useState(false);
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);
      let start = Math.max(2, pageIndex - 1);
      let end = Math.min(totalPages - 1, pageIndex + 1);

      if (pageIndex <= 3) { start = 2; end = Math.min(maxVisible, totalPages - 1); }
      if (pageIndex >= totalPages - 2) { start = Math.max(2, totalPages - maxVisible + 1); end = totalPages - 1; }

      if (start > 2) pages.push('...');
      for (let i = start; i <= end; i++) pages.push(i);
      if (end < totalPages - 1) pages.push('...');
      pages.push(totalPages);
    }

    return pages;
  };

  // Don't render if no data
  if (!totalCount || totalCount === 0) return null;

  return (
    <div className="Pagination">
      <div className="Pagination__pages">
        <button
          className="Pagination__btn"
          disabled={pageIndex <= 1}
          onClick={() => onPageChange(pageIndex - 1)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
        </button>

        {getPageNumbers().map((page, i) => (
          page === '...' ? (
            <span key={`dots-${i}`} className="Pagination__dots">...</span>
          ) : (
            <button
              key={page}
              className={`Pagination__btn ${page === pageIndex ? 'active' : ''}`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          )
        ))}

        <button
          className="Pagination__btn"
          disabled={pageIndex >= totalPages}
          onClick={() => onPageChange(pageIndex + 1)}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>

      {/* Page size dropdown */}
      <div className="Pagination__size">
        <button className="Pagination__size-btn" onClick={() => setShowSizeMenu(!showSizeMenu)}>
          {pageSize} {t('common:perPage')}
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>
        </button>
        {showSizeMenu && (
          <>
            <div className="Pagination__size-overlay" onClick={() => setShowSizeMenu(false)} />
            <div className="Pagination__size-menu">
              {pageSizes.map(size => (
                <button
                  key={size}
                  className={`Pagination__size-item ${size === pageSize ? 'active' : ''}`}
                  onClick={() => { onPageSizeChange(size); setShowSizeMenu(false); }}
                >
                  {size}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
